module.exports = __webpack_public_path__ + "static/media/background_POR.d06583b4.jpg";